import { useState } from "react";
import NotificationBanner from "./index";
import {
  useBannerNotifications,
  type BannerNotification,
} from "../../../hooks/useBannerNotifications";

const DISMISSED_STORAGE_KEY = "app-banner-dismissed-ids";

type BannerId = number | string;

interface SiteBannersProps {
  isAuthenticated: boolean | null;
}

const readDismissedIds = (): BannerId[] => {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(DISMISSED_STORAGE_KEY) || "[]");
    return Array.isArray(parsed) ? (parsed as BannerId[]) : [];
  } catch {
    return [];
  }
};

const SiteBanners = ({ isAuthenticated }: SiteBannersProps) => {
  const { data } = useBannerNotifications(isAuthenticated);
  const [dismissedBannerIds, setDismissedBannerIds] = useState<BannerId[]>(readDismissedIds);

  const handleDismiss = (id: BannerId) => {
    const newDismissed = [...dismissedBannerIds, id];
    setDismissedBannerIds(newDismissed);
    localStorage.setItem(DISMISSED_STORAGE_KEY, JSON.stringify(newDismissed));
  };

  const banners: BannerNotification[] = data ?? [];
  const visibleBanners = banners.filter((b) => !dismissedBannerIds.includes(b.id));

  if (visibleBanners.length === 0) {
    return null;
  }

  return (
    <div className="w-full fixed top-0 left-0 z-[9999] flex flex-col">
      {visibleBanners.map((banner) => (
        <NotificationBanner
          key={banner.id}
          notification={banner}
          onDismiss={() => handleDismiss(banner.id)}
        />
      ))}
    </div>
  );
};

export default SiteBanners;
